import {
  Button as ButtonAntd,
  Card as CardAntd,
  Divider as DividerAntd,
  Typography as TypographyAntd,
  Upload as UploadAntd,
} from 'antd';
import styled from 'styled-components';

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding-top: 0;
  }

  .height-85 {
    height: 85vh;
  }

  .margin-sides {
    margin: 0 8px;
  }
`;

export const Button = styled(ButtonAntd)`
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
  color: #fff;
  padding: 0px 31px;
  border: 1px solid #75aa4a;
  border-radius: ${props => props.borderradius || '6px'} !important;
  background: #75aa4a;

  &:hover,
  &:focus,
  &:active {
    color: #fff;
    border-color: #add290;
    background-color: #add290;
  }
`;

export const UploadButton = styled(ButtonAntd)`
  width: 100%;
  text-align: initial;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #bdbdbd;
  border: 1px solid #bdbdbd;
  border-radius: 4px !important;
  background: #fff;

  &:hover,
  &:focus,
  &:active {
    color: #dedede;
    border-color: #dedede;
  }
`;

export const Divider = styled(DividerAntd)`
  align-self: center;
  border-color: #676a6c;
`;

export const Upload = styled(UploadAntd)`
  .ant-upload {
    width: 100%;
  }
`;

export const Title = styled(TypographyAntd.Title)`
  font-weight: bold !important;
  font-size: 20px !important;
  line-height: 23px !important;
  letter-spacing: 0.25px !important;
  color: #4f4f4f !important;
`;

export const Text = styled(TypographyAntd.Text)`
  padding: 0 115px;
  text-align: center;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.25px;
  color: #828282;
`;

export const SubTitle = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #676a6c !important;
`;

export const DownloadLink = styled.a`
  font-weight: bold;
  color: #676a6c !important;
  text-decoration: underline;

  &:hover,
  &:focus,
  &:active {
    text-decoration: underline;
    opacity: 0.5;
  }
`;
